import { GridColDef } from "@mui/x-data-grid"
import { Organization } from "@/interfaces/organization"
import Link from "next/link";

export const columns: GridColDef[] = [
    {
        field: "name",
        headerName: "Name",
        flex: 2,
        minWidth: 150,
        renderCell: (params) => {
            const href = `/channels/${params.row?.id}`
            return <Link className='text-secondary-700 underline' href={href}> {params.value} </Link>
        },
    },
    {
        field: "state",
        headerName: "State",
        flex: 1,
        minWidth: 100,
        valueGetter: (_, row: Organization) => row.state?.name,
    },
    {
        field: "county",
        headerName: "County",
        flex: 1,
        minWidth: 120,
        valueGetter: (_, row: Organization) => row.county?.name,
    },
    {
        field: "type",
        headerName: "Channel Type",
        flex: 1,
        minWidth: 200,
        valueGetter: (_, row: Organization) => row.type.name,
    },
    {
        field: "meetings_length",
        headerName: "Total Meetings",
        type: "number",
        flex: 1,
        minWidth: 120,
    },
    {
        field: "last_meeting",
        headerName: "Last Meeting Finished",
        flex: 1,
        minWidth: 180,
        valueFormatter: (value?: string) => {
            if (value) {
                return new Date(value).toLocaleDateString("en-US", { dateStyle: "medium" })
            }
        },
    },
]
